import { URLs } from "./utils/constants";
const {
  BASE_URL_LOCAL,
  BASE_URL_QA,
  BASE_URL_RELEASE,
  BASE_URL_PROD,
  BASE_URL_RELEASE_FE,
  BASE_URL_QA_FE,
  BASE_URL_Prod_FE,
  BASE_URL_HYPERCOMPLY,
  BASE_URL_HYPERCOMPLY_PROD,
  BASE_URL_CLERK_AUTH,
  BASE_URL_CLERK_AUTH_PROD,
} = URLs;

const local = {
  apiGateway: {
    REGION: "",
    URL: BASE_URL_LOCAL,
    URL_FE: window.location.origin + "/",
    HC_URL: BASE_URL_HYPERCOMPLY,
    CLERK_AUTH_URL: BASE_URL_CLERK_AUTH,
  },
};
const alpha = {
  apiGateway: {
    REGION: "",
    URL: BASE_URL_QA,
    URL_FE: BASE_URL_QA_FE,
    HC_URL: BASE_URL_HYPERCOMPLY,
    CLERK_AUTH_URL: BASE_URL_CLERK_AUTH,
  },
  //   StripeKey: {
  //     Key: Stripe_key_Test,
  //   },
};

const beta = {
  apiGateway: {
    REGION: "",
    URL: BASE_URL_RELEASE,
    URL_FE: BASE_URL_RELEASE_FE,
    HC_URL: BASE_URL_HYPERCOMPLY,
    CLERK_AUTH_URL: BASE_URL_CLERK_AUTH,
  },
  //   StripeKey: {
  //     Key: Stripe_key_Test,
  //   },
};

const prod = {
  apiGateway: {
    REGION: "",
    URL: BASE_URL_PROD,
    URL_FE: BASE_URL_Prod_FE,
    HC_URL: BASE_URL_HYPERCOMPLY_PROD,
    CLERK_AUTH_URL: BASE_URL_CLERK_AUTH_PROD,
  },
  //   StripeKey: {
  //     Key: Stripe_key_Prod,
  //   },
};
export const Config = {
  // Add common config values here
  ...(process.env.REACT_APP_STAGE === "prod"
    ? prod
    : process.env.REACT_APP_STAGE === "release"
    ? beta
    : process.env.REACT_APP_STAGE === "qa"
    ? alpha
    : process.env.REACT_APP_STAGE === "local"
    ? local
    : alpha),
};
